import { render, staticRenderFns } from "./LayoutHost.vue?vue&type=template&id=a472e59c&"
import script from "./LayoutHost.vue?vue&type=script&lang=ts&"
export * from "./LayoutHost.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports